import api from "./index";

export const getMe = async (token) => {
  try {
    const res = await api.get("/users/me", {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const getMyPosts = async (token) => {
  try {
    const res = await api.get("/users/me/listings", {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const updateMe = async (token, payload) => {
  try {
    const res = await api.put("/users/me", payload, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const RequestPasswordReset = async(email)=>{
  try {
    const res = await api.post("/users/request-password-reset", { email });
    return res.data;
  } catch (error) {
    throw error;
  }
}

export const ResetPassword = async(token, new_password)=>{
  try {
    const res = await api.post("/users/reset-password", { token, new_password });
    return res.data;
  } catch (error) {
    throw error;
  }
}